import { render, staticRenderFns } from "./editor_property_panel.vue?vue&type=template&id=10b5196d&scoped=true"
import script from "./editor_property_panel.vue?vue&type=script&lang=js"
export * from "./editor_property_panel.vue?vue&type=script&lang=js"
import style0 from "./editor_property_panel.vue?vue&type=style&index=0&id=10b5196d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b5196d",
  null
  
)

export default component.exports